import { useApp, useTriggerAction, SplitText } from '@libs/core';
import { TWidget } from '@libs/types';
import React, { useState } from 'react';
import { TCardBalanceData, TCardBalanceDataMessages } from '../../../../types/data';
import { ButtonRowView } from '../../../Buttons/ButtonRowView';
import { PopupComponent } from '../../../UI/Popup/PopupComponent';
import { CardBalanceActionName } from '../utils/utils';

type TCancelAndReissueCard = {
    widget: TWidget<TCardBalanceData>;
    messages: TCardBalanceDataMessages;
};
export const CancelAndReissueCard = ({ widget, messages }: TCancelAndReissueCard) => {
    const [disclaimer, toggleDisclaimer] = useState(false);

    const { setPopup } = useApp();
    const { triggerActionsByType } = useTriggerAction(widget);

    return (
        <PopupComponent
            header={disclaimer ? <SplitText text={messages.reissueDescription} as={'p'} /> : null}
            externalContent={[
                <ButtonRowView
                    key="cancelAndReissueCard"
                    onClick={() => {
                        if (disclaimer) {
                            setPopup(null);
                            triggerActionsByType(CardBalanceActionName.getNewCard, { isShowLoader: true }).catch((e) => console.log(e));
                        } else {
                            toggleDisclaimer(true);
                        }
                    }}
                    label={disclaimer ? messages.getNewCardBtn : messages.cancelReissueCardBtn}
                    iconName={disclaimer ? 'ic_check' : 'ic_scissors'}
                />,
            ]}
        />
    );
};
